import type { FieldSchema } from './types';

type GetFormDataItem = (data: unknown, name: string) => unknown;

export const isFieldHidden = (field: FieldSchema, formData: unknown, getFormDataItem: GetFormDataItem): boolean => {
  let isHidden: unknown = Object.prototype.hasOwnProperty.call(field, 'isHidden')
    ? getFormDataItem(formData, field.isHidden as string)
    : false;

  if (field?.isHidden === 'yield_evaluation.source') {
    const source = getFormDataItem(formData, 'yield_evaluation.source');
    isHidden = source !== 'monthly';
  }

  if (Object.prototype.hasOwnProperty.call(field, 'revertHidden') && field?.revertHidden) {
    isHidden = !isHidden;
  }

  return Boolean(isHidden);
};
